import cookie from "js-cookie";

// use all the below mentioned Utility Functions, to create, rmeove and manipulate Cookies. ( in whole project )
// Here, we are using "js-cookie" npm, to work with cookies.

export const setCookie = (key, value, data) => {
  if (process.browser) {
    cookie.set(key, value, {
      expires: 1,
      path: "/",
      // sameSite: "None",
      // secure: false
    });
  } else {
    console.log("setCookie failed");
  }
};

export const removeCookie = (key) => {
  if (process.browser) {
    cookie.remove(key, {
      expires: 1,
    });
  }
};

export const getCookie = (key, req) => {
  return process.browser ? getCookieFromBrowser(key) : "";
};

export const getCookiees = (key, req) => {
  return process.browser
    ? getCookieFromBrowser(key)
    : getCookieFromServer(key, req);
};

const getCookieFromBrowser = (key) => {
  return cookie.get(key);
};

const getCookieFromServer = (key, req) => {
  if (!req.headers || !req.headers.cookie) {
    return null;
  }
  const rawCookie = req.headers.cookie
    .split(";")
    .find((c) => c.trim().startsWith(`${key}=`));
  if (!rawCookie) {
    return null;
  }
  return rawCookie.split("=")[1];
};
